import { ValueLegend } from "src/main";

import { usePerformanceHook } from "@iliotech/data-wire";

import { useGlobalPeriod } from "@iliotech/data-wire";
import { PerformanceByAllocationChart } from "src/components";
import { ReportWidgetProps } from "../../ReportWidgetProps";
import { useParams } from "react-router-dom";

export const PerformanceByAllocationWidget = (props: ReportWidgetProps) => {
  const portfolioId = useParams().portfolioId;
  const { performanceByAllocation, legendItems } = usePerformanceHook(
    portfolioId!,
    true,
    props.periodContext,
    props.structureContext
  );
  const { periodString } = props.periodContext || useGlobalPeriod();

  return (
    <div>
      <h6 className={"element-title"}>{"Performance by Allocation"}</h6>
      <p className={"period-string"}>{periodString}</p>
      <div style={{ height: 20 }} />
      <PerformanceByAllocationChart
        height={props.height}
        width={props.width}
        chartData={performanceByAllocation}
      />
      <ValueLegend small={props.isHalfHeight} items={legendItems || []} />
    </div>
  );
};
